import { render } from "./apSearch.vue?vue&type=template&id=124b5e7c&scoped=true&ts=true"
import script from "./apSearch.vue?vue&type=script&lang=ts"
export * from "./apSearch.vue?vue&type=script&lang=ts"

import "./apSearch.vue?vue&type=style&index=0&id=124b5e7c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-124b5e7c"]])

export default __exports__